













import {
  adminTimeDistanceFromNow,
  cappedTimeDistanceFromNow
} from '~/utils/date'
import { mapGetters } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    }),
    isDate() {
      return this.name === 'created' || this.name === 'modified'
    },
    isParkedPrice() {
      return this.name === 'price_parked'
    },
    dateValue() {
      if (this.userIsAdmin) {
        return adminTimeDistanceFromNow(this.value)
      }
      return cappedTimeDistanceFromNow(this.value, 60, {
        locale: this.$i18n.locale,
        addSuffix: true,
        addPrefix: false,
        includeSeconds: true
      })
    }
  }
})
